import useDeviceWidth from '@/components/useDeviceWidth';
import { Button } from '@usitsdasdesign/dds-react';
import { useEffect, useState } from 'react';

const Pagination = ({
    value = 1,
    pageNumberInSection = 5,
    pageLength = 100,
    isDisabled,
    buttonsMode = 'text',
    customClass,
    pageChanged = () => false,
    setPagination = () => { }
}) => {
    const [currentPage, setCurrentPage] = useState(value);

    const { deviceWidth } = useDeviceWidth();
    const isMobile = deviceWidth <= 480;
    const pageSize = isMobile ? 3 : pageNumberInSection;

    const totalPages = Math.ceil(pageLength);

    const handlePageChange = (page) => {
        if (page >= 1 && page <= totalPages && page !== currentPage) {
            setCurrentPage(page);
            setPagination((prev) => ({ ...prev, currentPage: page }))
            pageChanged(page);
        }
    };
    useEffect(() => {
        setCurrentPage(value);
        setPagination((prev) => ({ ...prev, currentPage: value }))
    }, [value]);

    const renderPaginationButtons = () => {
        const buttons = [];
        const maxPagesToShow = pageSize;    
        let startPage = Math.max(1, currentPage - Math.floor(maxPagesToShow / 2));
        const endPage = Math.min(totalPages, startPage + maxPagesToShow - 1);

        if (endPage === totalPages) {
            startPage = Math.max(1, totalPages - maxPagesToShow + 1);
        }
    
        for (let i = startPage; i <= endPage; i++) {
            buttons.push(
                <Button
                    key={i}
                    onClick={() => handlePageChange(i)}
                    isDisabled={isDisabled}
                    label={buttonsMode === 'text' ? i : null}
                    size='m'
                    color={currentPage === i ? 'green' : 'dark'}
                    kind={currentPage === i ? 'primaryLoud' : 'silent'}
                />
            );
        }
    
        if (startPage > 1) {
            buttons.unshift(
                <Button
                    key="first"
                    onClick={() => handlePageChange(1)}
                    isDisabled={isDisabled}
                    label={buttonsMode === 'text' ? 1 : null}
                    size='m'
                    color={currentPage === 1 ? 'green' : 'dark'}
                    kind='silent'
                />
            );
            if (startPage > 2) {
                buttons.splice(1, 0,
                    <Button
                        key="start-dots"
                        className="pagination-btn dots"
                        disabled
                        style={{ pointerEvents: 'none' }}
                        label='...'
                        kind='silent'
                        size='m'
                        color='dark'
                    />
                );
            }
        }
    
        if (endPage < totalPages) {
            if (endPage < totalPages - 1) {
                buttons.push(
                    <Button
                        key="end-dots"
                        className="pagination-btn dots"
                        disabled
                        style={{ pointerEvents: 'none' }}
                        label='...'
                        kind='silent'
                        size='m'
                        color='dark'
                    />
                );
            }
            buttons.push(
                <Button
                    key={totalPages}
                    onClick={() => handlePageChange(totalPages)}
                    isDisabled={isDisabled}
                    label={buttonsMode === 'text' ? totalPages : null}
                    size='m'
                    color={currentPage === totalPages ? 'green' : 'dark'}
                    kind='silent'
                />
            );
        }
    
        return buttons;
    };
    

    return (
        <div className={`pagination-container flex ${customClass}`}>
            <Button
                onClick={() => handlePageChange(currentPage - 1)}
                isDisabled={currentPage === 1 || isDisabled}
                label='Previous'
                kind='silent'
                size='m'
                color='dark'
            />
            {renderPaginationButtons()}
            <Button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages || isDisabled}
                label='Next'
                kind='silent'
                size='m'
                color='dark'
            />
        </div>
    );
};

export default Pagination;
